import React from "react";
import PartnerWithUsHeader from "./PartnerWithUsPage/PartnerWithUsHeader";
import PWUCollaborate from "./PartnerWithUsPage/PWUCollaborate";
import PWUCards from "./PartnerWithUsPage/PWUCards";
import PWUTrustedCards from "./PartnerWithUsPage/PWUTrustedCards";
import PWUFooterSection from "./PartnerWithUsPage/PWUFooterSection";

const PartnerWithUsPage = () => {
  return (
    <>
      <PartnerWithUsHeader />
      <PWUCollaborate />
      <PWUCards />
      <PWUTrustedCards />
      <PWUFooterSection />
    </>
  )
}

export default PartnerWithUsPage